<template>
  <div class="section-partners">
    <div class="partners-header">
      <h2 class="partners-title">{{ displayData.title }}</h2>
      <span class="partners-link">자세히 보기 →</span>
    </div>

    <div class="partners-logos">
      <div
        v-for="(logo, idx) in displayLogos"
        :key="idx"
        class="partner-logo-item"
      >
        <img
          v-if="logo.logoUrl"
          :src="logo.logoUrl"
          :alt="logo.altText || '파트너 로고'"
          class="partner-logo-img"
        />
        <div v-else class="partner-logo-placeholder">
          <span>{{ logo.altText || `파트너 ${idx + 1}` }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const DEFAULT_DATA = {
  title: '서티라이프는 25곳 이상의 의료 제조사와 함께합니다',
  logos: Array.from({ length: 8 }, (_, i) => ({
    logoUrl: '',
    altText: `파트너 ${i + 1}`,
  })),
};

export default {
  name: 'SectionPartners',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    displayData() {
      return {
        title: this.data?.title || DEFAULT_DATA.title,
        logos: this.data?.logos?.length ? this.data.logos : DEFAULT_DATA.logos,
      };
    },
    displayLogos() {
      return this.displayData.logos;
    },
  },
};
</script>

<style scoped>
.section-partners {
  background: #fff;
  padding: 60px 24px;
}

.partners-header {
  max-width: 1100px;
  margin: 0 auto 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.partners-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
}

.partners-link {
  font-size: 14px;
  color: #1677ff;
  cursor: pointer;
}

.partners-logos {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 8px;
}

.partner-logo-item {
  flex: 0 0 auto;
  width: 140px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.partner-logo-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.partner-logo-placeholder {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bfbfbf;
  font-size: 12px;
  border: 1px dashed #d9d9d9;
}
</style>
